<template>
  <Carousel
    :perPageCustom="[
      [320, 1],
      [768, 1],
      [1024, 2],
    ]"
    :paginationEnabled="true"
    paginationActiveColor="#3A4BE4"
    :paginationPadding="paginationPadding"
    :paginationSize="paginationSize"
    autoplay
  >
    <Slide v-for="(slide, i) in loadData" :key="i">
      <div style="margin: 0 12px">
        <a :href="slide.link">
          <img :src="slide.image" class="slider-item" />
        </a>
      </div>
    </Slide>
  </Carousel>
</template>

<script>
import Axios from 'axios';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'Hero',
  components: { Carousel, Slide },
  data() {
    {
      return {
        sliderResponsive: {
          0: { items: 1, nav: false, dots: false },
          600: { items: 2, nav: false, dots: false },
        },
        paginationPadding: 1,
        paginationSize: 8,
        loaded: false,
        loadData: [],
        error: false,
        errorMessage: null,
      };
    }
  },
  mounted() {
    Axios.get(process.env.VUE_APP_API + 'banner/1')
      .then((response) => {
        this.loadData = response.data.data;
      })
      .catch((error) => {
        console.log(error);
        this.error = true;
        this.errorMessage = error;
      })
      .finally(() => (this.loaded = true));
  },
};
</script>

<style scoped>
.slider-item {
  border-radius: 5px;
  width: 100%;
}

.VueCarousel-pagination {
  background: #000 !important;
}

@media screen and (max-width: 768px) {
  .slider-item {
    /*height: 150px;*/
    /*width: 100%;*/
  }
}
</style>
